import { useContext } from 'react';
import { assert } from 'ts-essentials';

import AnalyticsIntegrationsContext from './context';

const useAnalyticsIntegrationsContext = () => {
  const ctx = useContext(AnalyticsIntegrationsContext);

  assert(ctx, '`AnalyticsIntegrationsContext` not found in React tree');

  return ctx;
};

export default useAnalyticsIntegrationsContext;
